// export const baseURL = 'https://qaapi.mattersuite.com/api'
export const baseURL = 'https://api.mattersuite.com/api'
// export const baseURL = 'http://localhost:8000'
export const tokenKey = 'authToken'
export const ipStackKey='5a98f00ee20d10cfd27571890e78c060'